const PLAN_OFFERS_ORDER = {
  'Anual': 0,
  'Semestral': 1,
  'Débito Mensal': 2,
  'Trimestral': 3,
  'Bianual': 4,
  'Mensal': 5,
};

const HIGHLIGHT_OFFER_PRIMARY = 'promo fitness';
const HIGHLIGHT_OFFER_SECONDARY = 'fitness';

export {
  PLAN_OFFERS_ORDER,
  HIGHLIGHT_OFFER_PRIMARY,
  HIGHLIGHT_OFFER_SECONDARY
};
